import { Controller } from '@hotwired/stimulus'

// Scrollspy: highlights the active anchor link as the user scrolls through sections
export default class DesignPageController extends Controller {
  static targets = ['content', 'anchors'];

  #onScroll = null;

  connect() {
    this.#startScrollspy();
  }

  disconnect() {
    if (this.#onScroll) window.removeEventListener('scroll', this.#onScroll);
  }

  #startScrollspy() {
    const sections = [...this.contentTarget.querySelectorAll('section[id]')];
    if (!sections.length) return;

    const HEADER_OFFSET = 140;

    this.#onScroll = () => {
      const active = sections
        .filter(el => el.getBoundingClientRect().top <= HEADER_OFFSET)
        .at(-1);
      const activeId = active?.id ?? sections[0]?.id;
      this.anchorsTarget.querySelectorAll('.design-anchor-link').forEach(a => {
        a.classList.toggle('active', a.dataset.sectionId === activeId);
      });
    };

    window.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#onScroll();
  }
}
